import { render, staticRenderFns } from "./ModalShortcut.vue?vue&type=template&id=019bebfe&"
import script from "./ModalShortcut.vue?vue&type=script&lang=js&"
export * from "./ModalShortcut.vue?vue&type=script&lang=js&"
import style0 from "./ModalShortcut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports